export enum CalendarTheme {
  Primary,
  Secondary,
}
